/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsUserResponse } from './RevisdomAPIViewModelsUserResponse';
import {
    RevisdomAPIViewModelsUserResponseFromJSON,
    RevisdomAPIViewModelsUserResponseFromJSONTyped,
    RevisdomAPIViewModelsUserResponseToJSON,
    RevisdomAPIViewModelsUserResponseToJSONTyped,
} from './RevisdomAPIViewModelsUserResponse';

/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryEntryResponse
 */
export interface RevisdomAPIViewModelsEntryEntryResponse {
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryEntryResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryEntryResponse
     */
    projectId?: number;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryEntryResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryEntryResponse
     */
    path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryEntryResponse
     */
    status?: RevisdomAPIViewModelsEntryEntryResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryEntryResponse
     */
    entryType?: RevisdomAPIViewModelsEntryEntryResponseEntryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryEntryResponse
     */
    thumbnailUrl?: string | null;
    /**
     * 
     * @type {Array<RevisdomAPIViewModelsUserResponse>}
     * @memberof RevisdomAPIViewModelsEntryEntryResponse
     */
    share?: Array<RevisdomAPIViewModelsUserResponse> | null;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsEntryEntryResponse
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsEntryEntryResponse
     */
    updatedAt?: Date | null;
}


/**
 * @export
 */
export const RevisdomAPIViewModelsEntryEntryResponseStatusEnum = {
    NeedsReview: 'NeedsReview',
    Updated: 'Updated',
    Approved: 'Approved'
} as const;
export type RevisdomAPIViewModelsEntryEntryResponseStatusEnum = typeof RevisdomAPIViewModelsEntryEntryResponseStatusEnum[keyof typeof RevisdomAPIViewModelsEntryEntryResponseStatusEnum];

/**
 * @export
 */
export const RevisdomAPIViewModelsEntryEntryResponseEntryTypeEnum = {
    Project: 'Project',
    Folder: 'Folder',
    File: 'File',
    Version: 'Version'
} as const;
export type RevisdomAPIViewModelsEntryEntryResponseEntryTypeEnum = typeof RevisdomAPIViewModelsEntryEntryResponseEntryTypeEnum[keyof typeof RevisdomAPIViewModelsEntryEntryResponseEntryTypeEnum];


/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryEntryResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryEntryResponse(value: object): value is RevisdomAPIViewModelsEntryEntryResponse {
    return true;
}

export function RevisdomAPIViewModelsEntryEntryResponseFromJSON(json: any): RevisdomAPIViewModelsEntryEntryResponse {
    return RevisdomAPIViewModelsEntryEntryResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'name': json['name'] == null ? undefined : json['name'],
        'path': json['path'] == null ? undefined : json['path'],
        'status': json['status'] == null ? undefined : json['status'],
        'entryType': json['entryType'] == null ? undefined : json['entryType'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'share': json['share'] == null ? undefined : ((json['share'] as Array<any>).map(RevisdomAPIViewModelsUserResponseFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function RevisdomAPIViewModelsEntryEntryResponseToJSON(json: any): RevisdomAPIViewModelsEntryEntryResponse {
    return RevisdomAPIViewModelsEntryEntryResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryEntryResponseToJSONTyped(value?: RevisdomAPIViewModelsEntryEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'projectId': value['projectId'],
        'name': value['name'],
        'path': value['path'],
        'status': value['status'],
        'entryType': value['entryType'],
        'thumbnailUrl': value['thumbnailUrl'],
        'share': value['share'] == null ? undefined : ((value['share'] as Array<any>).map(RevisdomAPIViewModelsUserResponseToJSON)),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt'] as any).toISOString()),
    };
}

